import { Input, Component, Output, EventEmitter } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { ButtonColorsEnum } from './button-colors.enum';

@Component({
  selector: 'tablesready-btn-group-control',
  templateUrl: './button-group-control.component.html',
})
export class ButtonGroupControlComponent<T> {
  @Output() btnClick = new EventEmitter<T>();
  @Input() items: Array<Record<string, T>> = [];
  @Input() bindName?: string;
  @Input() bindValue?: string;
  @Input() control?: AbstractControl;
  @Input() buttonType = ButtonColorsEnum.info;
  @Input() disabled = false;

  select(selectedValue: T): void {
    this.btnClick.emit(selectedValue);
    if (!this.control) {
      return;
    }

    this.control.setValue(selectedValue);
    this.control.markAsTouched();
  }

  getBtnClass(item: Record<string, T>): string {
    if (!this.control || !this.bindValue) {
      return `btn-outline-${this.buttonType}`;
    }

    return this.control.value === item[this.bindValue] ? `btn-${this.buttonType}` : `btn-outline-${this.buttonType}`;
  }
}
